<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
       
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;"> Add Faculty </div>
      </ion-col>

      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!--addfaculty-form.component.html -->

    <form [formGroup]="addFacultyForm" style="margin: 10px;">
      <ion-row>
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Faculty Name <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="facultyName" placeholder="Enter faculty name" />
            <mat-error *ngIf="addFacultyForm.get('facultyName')?.hasError('required') && addFacultyForm.get('facultyName')?.touched">
            Faculty name is required
            </mat-error>
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Contact No. <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput type="number" formControlName="contactNumber" placeholder="Enter contact number" />
            <mat-error *ngIf="addFacultyForm.get('contactNumber')?.hasError('required') && addFacultyForm.get('contactNumber')?.touched">
           Contact no. is required
            </mat-error>
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Email ID <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput type="email" formControlName="email" placeholder="Enter email ID" />
            <mat-error *ngIf="addFacultyForm.get('email')?.hasError('required') && addFacultyForm.get('email')?.touched">
             Email ID is required
            </mat-error>
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Details <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="details" placeholder="Enter details" />
            <mat-error *ngIf="addFacultyForm.get('details')?.hasError('required') && addFacultyForm.get('details')?.touched">
             Details is required
             </mat-error>
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Link <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="link" placeholder="Enter link" />
            <mat-error *ngIf="addFacultyForm.get('link')?.hasError('required') && addFacultyForm.get('link')?.touched">
             Link is required
              </mat-error>
          </mat-form-field>
        </ion-col>
      </ion-row>
    
      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="closeDialog()">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName" (click)="submitFaculty()">
            Submit
          </button>
        </ion-col>
      </ion-row>
    </form>
    
  </div>
</div>
